<script setup lang="ts">
import SvgAll from '~/assets/svg/all.svg'
import SvgHot from '~/assets/svg/hot.svg'

const selected = ref(0)

const categories = [{
  title: 'All',
  icon: SvgAll,
}, {
  title: 'Hot',
  icon: SvgHot,
}, {
  title: 'Rank#1',
}, {
  title: 'Top 10',
}, {
  title: 'L1/L2',
}, {
  title: 'Meme',
}, {
  title: 'GameFi',
}, {
  title: 'Utility',
}, {
  title: 'DeFi',
}]

const ambassadors = [{
  title: 'Soong Hyu-en',
  tag: 'MissPEPE Rank#14',
  watch: 9300,
  cover: '/images/pla-1.webp',
}, {
  title: 'Bae Soo Young',
  tag: 'MissETH Rank#8',
  watch: 9300,
  cover: '/images/pla-2.webp',
}, {
  title: 'Lee Min-soong',
  tag: 'MissFTM Rank#2',
  watch: 9300,
  cover: '/images/pla-3.webp',
}, {
  title: 'Hong Su Jin',
  tag: 'MissAVAX Rank#18',
  watch: 2300,
  cover: '/images/pla-4.webp',
}, {
  title: 'Kwan Ji-anh',
  tag: 'MissETH Rank#1',
  watch: 232500,
  cover: '/images/pla-5.webp',
}, {
  title: 'Kim Hyuna',
  tag: 'MissDOT Rank#1',
  watch: 145000,
  cover: '/images/pla-6.webp',
}]
</script>

<template>
  <div container w-full>
    <div row items-center>
      <h3 flex-grow text-24px font-bold>
        Popular Live Ambassadors
      </h3>
      <button class="b-1 b-#ce0000 rounded-full bg-transparent p-[8px_16px] text-14px">
        See All
      </button>
    </div>

    <LiveSearchBarBlack my-24px />

    <LiveCategories v-model="selected" :categories />

    <div grid grid-cols-1 mt-32px gap-17px lg:grid-cols-3 sm:grid-cols-2>
      <div v-for="ambassador, idx in ambassadors" :key="idx" overflow-hidden b-1 rounded-16px b-solid class="b-#585858">
        <div relative h-130px>
          <img :src="ambassador.cover" object-cover size-full :alt="ambassador.title">
          <div absolute inset-0 class="mask" />
          <div absolute left-16px top-16px row items-center rounded-24px class="bg-[rgba(31,29,43,0.76)] p-2px pr-10px">
            <div class="bg-#f15858 p-[4px_8px] lh-130%" rounded-20px text-12px font-600>
              Live
            </div>
            <svg ml-8px xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M14.1667 6.09995C12.6267 3.67995 10.3734 2.28662 8.00004 2.28662C6.81337 2.28662 5.66004 2.63329 4.60671 3.27995C3.55337 3.93329 2.60671 4.88662 1.83337 6.09995C1.16671 7.14662 1.16671 8.84662 1.83337 9.89329C3.37337 12.32 5.62671 13.7066 8.00004 13.7066C9.18671 13.7066 10.34 13.36 11.3934 12.7133C12.4467 12.06 13.3934 11.1066 14.1667 9.89329C14.8334 8.85329 14.8334 7.14662 14.1667 6.09995ZM8.00004 10.6933C6.50671 10.6933 5.30671 9.48662 5.30671 7.99995C5.30671 6.51329 6.50671 5.30662 8.00004 5.30662C9.49337 5.30662 10.6934 6.51329 10.6934 7.99995C10.6934 9.48662 9.49337 10.6933 8.00004 10.6933Z" fill="white" />
              <path d="M7.99998 6.09338C6.95331 6.09338 6.09998 6.94672 6.09998 8.00005C6.09998 9.04672 6.95331 9.90005 7.99998 9.90005C9.04664 9.90005 9.90664 9.04672 9.90664 8.00005C9.90664 6.95338 9.04664 6.09338 7.99998 6.09338Z" fill="white" />
            </svg>
            <span ml-4px text-12px font-600 class="lh-130%">
              {{ $n(ambassador.watch, { notation: 'compact' }) }}
            </span>
          </div>
        </div>

        <div p-16px>
          <p text-18px font-bold>
            {{ ambassador.title }}
          </p>

          <div mt-12px row>
            <div overflow-x-hidden text-ellipsis rounded-full bg-black text-nowrap text-13px class="p-[4px_10px] text-center text-#f00">
              {{ ambassador.tag }}
            </div>

            <div flex-grow />

            <button class="p-[4px_10px]" ml-4px btn-primary shrink-0 rounded-full text-13px>
              Send ROMA
            </button>
            <button class="p-[4px_10px]" ml-4px btn shrink-0 rounded-full text-13px>
              Join Chat
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mask {
  background: linear-gradient(
    180deg,
    rgba(31, 29, 43, 0) 18.01%,
    #1f1d2b 136.79%
  );
}
</style>
